import { userConst } from '../consts';

export function reg(state = {}, action) {
    switch (action.type) {
        case userConst.REGISTER_REQUEST:
            return { registering: true };
        case userConst.REGISTER_SUCCESS:
            return {};
        case userConst.REGISTER_FAILURE:
            return {
                errors: action.errors
            };
        case userConst.CLEAR_ERRORS:
            return {
                ...state,
                errors: undefined
            };
        default:
            return state;
    }
}
